import { useState } from "react";
import { toast } from "sonner";
import { errText } from "@/lib/api";
import { Panel, Btn, fmt, useOps } from "./ui";

export const Mark = ({ ok }) => (
  <span className={`mono w-10 shrink-0 text-[10px] font-semibold ${ok === true ? "text-green-400" : ok === false ? "text-red-400" : "text-slate-500"}`}>
    {ok === true ? "OK" : ok === false ? "FAIL" : "SKIP"}
  </span>
);

export default function HealthChecks({ checks, onRan }) {
  const { api } = useOps();
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await api.post("/healthchecks/run"); toast.success("Checks finished"); onRan(); }
    catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const results = checks?.results || [];
  const bad = results.filter((r) => r.ok === false).length;
  return (
    <Panel title={`Health checks ${results.length ? `(${bad} failing)` : ""}`} className="lg:col-span-3" testid="health-checks"
      actions={<>
        <span className="text-[11px] text-slate-500">{checks ? `last run ${fmt(checks.at)} · hourly` : "not run yet"}</span>
        <Btn onClick={run} disabled={busy} data-testid="health-checks-run">{busy ? "Checking…" : "Run checks now"}</Btn>
      </>}>
      <div className="grid gap-x-6 md:grid-cols-2">
        {results.map((r) => (
          <div key={r.id} data-testid={`health-check-${r.id}`} className="flex gap-2 border-b border-[#243144] py-1 text-[11px] last:border-0">
            <Mark ok={r.ok} />
            <span className="w-64 shrink-0 text-slate-200">{r.label}</span>
            <span className="min-w-0 break-all text-slate-500">{r.detail}</span>
          </div>
        ))}
      </div>
    </Panel>
  );
}
